import React, { useRef, useEffect } from 'react';
import { Box, Typography } from '@mui/material';

const ITEM_HEIGHT = 50;

const SlotWheel = ({ items, currentValue, onSelect, unit }) => {
  const scrollRef = useRef(null);
  const timerRef = useRef(null);

  useEffect(() => {
    return () => { if (timerRef.current) clearTimeout(timerRef.current); };
  }, []);

  useEffect(() => {
    const index = items.indexOf(currentValue);
    if (index !== -1 && scrollRef.current) {
      scrollRef.current.scrollTop = index * ITEM_HEIGHT;
    }
  }, [items, currentValue]);

  const handleScroll = (e) => {
    const container = e.currentTarget;
    if (timerRef.current) clearTimeout(timerRef.current);

    timerRef.current = setTimeout(() => {
      if (container) {
        const index = Math.round(container.scrollTop / ITEM_HEIGHT);
        const selectedValue = items[index];
        if (selectedValue !== undefined && selectedValue !== currentValue) {
          onSelect(selectedValue);
        }
      }
    }, 100);
  };

  return (
    <Box sx={{ flex: 1, position: 'relative', height: ITEM_HEIGHT * 3, overflow: 'hidden', bgcolor: '#fff' }}>
      <Box sx={{ 
        position: 'absolute', top: ITEM_HEIGHT, left: 0, right: 0, height: ITEM_HEIGHT, 
        borderTop: '1px solid #eee', borderBottom: '1px solid #eee', 
        bgcolor: 'rgba(25, 118, 210, 0.04)', pointerEvents: 'none', zIndex: 1 
      }} />
      <Box 
        ref={scrollRef} 
        onScroll={handleScroll} 
        sx={{ 
          height: '100%', overflowY: 'auto', scrollSnapType: 'y mandatory', 
          '&::-webkit-scrollbar': { display: 'none' }, py: `${ITEM_HEIGHT}px`,
          WebkitOverflowScrolling: 'touch'
        }}
      >
        {items.map((item, i) => (
          <Box key={i} sx={{ height: ITEM_HEIGHT, display: 'flex', alignItems: 'center', justifyContent: 'center', scrollSnapAlign: 'center' }}>
            <Typography sx={{ 
              fontSize: currentValue === item ? '1.15rem' : '0.9rem', 
              fontWeight: currentValue === item ? 800 : 400, 
              color: currentValue === item ? 'primary.main' : 'text.disabled' 
            }}>
              {String(item).padStart(2, '0')}{unit}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default SlotWheel;